import AsyncStorage from '@react-native-async-storage/async-storage';
const asyncStorageProvider = () => {
    const storageName = 'AsyncStorageProvider';
    const getWithKey = (key) => AsyncStorage.getItem(key);
    const setWithKey = (key, object) => AsyncStorage.setItem(key, object);
    const deleteWithKey = (key) => AsyncStorage.removeItem(key);
    return {
        storageName,
        getWithKey,
        setWithKey,
        deleteWithKey,
    };
};
export default asyncStorageProvider;
//# sourceMappingURL=asyncStorageProvider.js.map